<template>
  <div class="main" v-if="indexdata" >

    <div class="free_course_box">
      <div class="tit">
        <span class="t1">免费试听课程</span>
        <span class="t2">FREE AUDITION</span>
      </div>

      <el-carousel height="210px" :autoplay="false" :loop="false" >
        <el-carousel-item v-for="(item, index) in indexdata.f_free_course_lesson_list" :key="index">
          <div class='item' v-for="sub in item" :key="sub.id">
           
            <div class="tit_name">
              <span class="f1">{{sub.course_name}}</span>
              <span class="f2">{{sub.lesson_short_desc}}</span>
            </div>
             <div class="tit_info">
               <div class="imgbox"  @click="onLook(sub.course_id)">
                 <img :src="sub.lesson_image" alt="" >
                  <div class="playBtn">
                    <a href="#" title="start">start</a>
                  </div>
               </div>
               <div class="info">
                <div class="l l1"><i class="el-icon-view"></i>总观看数 <span>{{sub.view_count > 100000 ? sub.view_count+'W+' : sub.view_count}}</span> </div>
                <div class="l l2"><i class="el-icon-time"></i>总观时长 <span>{{sub.view_times_total > 100000 ? sub.view_times_total+'W+' : sub.view_times_total}}</span> </div>
                <div class="l l3"><i class="el-icon-user"></i>科目学员数 <span>{{sub.view_member_count > 100000 ? sub.view_member_count+'W+' : sub.view_member_count}}</span> </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>

    </div>

    <div class="teacher_box">

      <div class="box">
        <div class="tit">{{indexdata.teacher_desc_title}}</div>
        <div class="content">{{indexdata.teacher_desc_content}}</div>

        <el-carousel :interval="4000" type="card" height="396px">
          <el-carousel-item v-for="item in indexdata.teacher_list" :key="item.id">
            <div class="tbox">
              <img :src="item.teacher_image" alt="" >
              <div class="tname">讲师：{{item.teacher_name}}</div>
              <div class="tdesc">{{item.teacher_desc}}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

    </div>

    <div class="banner_box middle_banner_box">
      <div class="box">
        <a v-for="item in indexdata.index_middle_banner" :key="item.id" :href="item.banner_url" target="_blank">
          <img :src="item.banner_image" alt="" >
        </a>
      </div>
    </div>

    <div class="hot_course_list" >
      <div class="tit">
        <span class="t1">热门课程</span>
        <span class="t2">Popular courses</span>
      </div>

      <el-carousel height="420px" :autoplay="false" :loop="false" >
        <el-carousel-item v-for="(item,index) in indexdata.f_hot_course_list" :key="index">
          <div class='item' v-for="sub in item" :key="sub.id" >
           
            <div class="tit_name">
              <span class="f1">{{sub.cate_name}}</span>
              <span class="f2">{{sub.course_name}}</span>
            </div>
             <div class="tit_info">
               <div class="imgbox" @click="onClass(sub.id)">
                 <img :src="sub.course_image" alt="" >
                 <div class="playBtn">
                    <a href="#" title="start">start</a>
                 </div>
               </div>
               <div class="info">
                <div class="l l1"><i class="el-icon-view"></i>总观看数 <span>{{sub.view_count > 100000 ? sub.view_count+'W+' : sub.view_count}}</span> </div>
                <div class="l l2"><i class="el-icon-time"></i>总观时长 <span>{{sub.view_times_total > 100000 ? sub.view_times_total+'W+' : sub.view_times_total}}</span> </div>
                <div class="l l3"><i class="el-icon-user"></i>科目学员数 <span>{{sub.view_member_count > 100000 ? sub.view_member_count+'W+' : sub.view_member_count}}</span> </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>

    </div>

    <div class="banner_box bottom_banner_box">
      <div class="box">
        <a v-for="item in indexdata.index_bottom_banner" :key="item.id" :href="item.banner_url" target="_blank">
          <img :src="item.banner_image" alt="" >
        </a>
      </div>
    </div>

    <div class="recommend_course_list_box" >
      <div class="recommend_course_list" >
        <div class="tit">
          <span class="t1">推荐课程</span>
          <span class="t2">Recommended courses</span>
        </div>

        <el-carousel height="210px" :autoplay="false" :loop="false" >
          <el-carousel-item v-for="(item,index) in indexdata.f_recommend_course_list" :key="index">
            <div class='item' v-for="sub in item" :key="sub.id">
            
              <div class="tit_name">
                <span class="f1">{{sub.cate_name}}</span>
                <span class="f2">{{sub.course_name}}</span>
              </div>
              <div class="tit_info">
                <div class="imgbox" @click="onClass(sub.id)">
                  <img :src="sub.course_image" alt="" >
                  <div class="playBtn">
                    <a href="#" title="start">start</a>
                  </div>
                </div>
                <div class="info">
                  <div class="l l1"><i class="el-icon-view"></i>总观看数 <span>{{sub.view_count > 100000 ? sub.view_count+'W+' : sub.view_count}}</span> </div>
                  <div class="l l2"><i class="el-icon-time"></i>总观时长 <span>{{sub.view_times_total > 100000 ? sub.view_times_total+'W+' : sub.view_times_total}}</span> </div>
                  <div class="l l3"><i class="el-icon-user"></i>科目学员数 <span>{{sub.view_member_count > 100000 ? sub.view_member_count+'W+' : sub.view_member_count}}</span> </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>

      </div>
    </div>

    <!-- <div class="fc">

      <div class="ma">
        <div class="ma_panel">
        </div>
         <img :src="contactInfo.contact_wechat_qrcode" alt="" >
      </div>
      <div class="dh">
        <div class="dh_panel"></div>
        <div class="dh_num">咨询电话：{{contactInfo.contact_phone_num}}</div>
      </div>

      <div class="bm" @click="onBackIndex">
      </div>

      <div class="db" @click="onBackTop">
      </div>

    </div> -->
     
  </div>
</template>

<script>


export default {
  data:function () {
    return {
      indexdata:null,
      contactInfo:null,
    }
  },
  created(){
    this.fetch();
    // this.fetch_contactInfo();
  },
  methods:{
    async fetch_contactInfo(){
      let data = await this.$fly.get('/common/contactInfo');

      this.contactInfo = data;
    },
   async fetch(){
    let data = await this.$fly.get('/index/index');

   
    //组合免费课
    data.f_free_course_lesson_list = [];
    for (let i = 0; i < data.free_course_lesson_list.length; i++) {
      let f = parseInt(i/3);
      
      if (data.f_free_course_lesson_list[f]){
       data.f_free_course_lesson_list[f].push(data.free_course_lesson_list[i]);
      }else{
         data.f_free_course_lesson_list[f] = [];
         data.f_free_course_lesson_list[f].push(data.free_course_lesson_list[i]);
      }
    }

    //热门课程
    data.f_hot_course_list = [];
    for (let i = 0; i < data.hot_course_list.length; i++) {
      let f = parseInt(i/6);
      
      if (data.f_hot_course_list[f]){
       data.f_hot_course_list[f].push(data.hot_course_list[i]);
      }else{
         data.f_hot_course_list[f] = [];
         data.f_hot_course_list[f].push(data.hot_course_list[i]);
      }
    }

    //推荐课程
    data.f_recommend_course_list = [];
    for (let i = 0; i < data.recommend_course_list.length; i++) {
      let f = parseInt(i/3);
      
      if (data.f_recommend_course_list[f]){
       data.f_recommend_course_list[f].push(data.recommend_course_list[i]);
      }else{
         data.f_recommend_course_list[f] = [];
         data.f_recommend_course_list[f].push(data.recommend_course_list[i]);
      }
    }

    this.indexdata = data;
    console.log("indexdata:",this.indexdata);

    if (this.$route.name === 'Main' ){
      this.$store.state.bannerlist = this.indexdata.index_top_banner;
    }

   },

  onLook(course_id){
    console.log("播放的课程id:",course_id);
    
    this.$router.push({ name: 'Look', params: { id: course_id }})
  },
  onClass(course_id){
    console.log("课程详情页id:",course_id);
    
    this.$router.push({ name: 'Class', params: { id: course_id }})
  },
  onBackTop(){
      let pp=document.documentElement;
      let stop=document.body;
      let timer = setInterval(function(){
          //获取滚动条的滚动高度
          let osTop = pp.scrollTop || stop.scrollTop;
          //用于设置速度差，产生缓动的效果
          let speed = Math.floor(-osTop / 6);
          pp.scrollTop = stop.scrollTop = osTop + speed;
          //用于阻止滚动事件清除定时器
          // let isTop = true;  
          if(osTop == 0){
              clearInterval(timer);
          }
      },10);
   },
   onBackIndex(){
     console.log(this.$router);
     if (this.$router.history.current.name === "Main"){
       this.onBackTop();
     }else{
       this.$router.push({ name: 'Main'});
     }
   }
  
  }
}
</script>

<style lang='scss'>

.main{
  
  .topbox{
    position: relative;
    overflow: hidden;

    .el-carousel__item{
      display: flex;
      justify-content:center;
      align-items:center;
      
      img {
        width: 1924px;
        height: 592px;
      }
    }

    .el-carousel__button{
      width: 16px;
      height: 16px;
      border-radius: 8px;
    }

    .is-active button {
      background-color: #00B3A4;
    }

    .el-carousel__arrow{
      display: none;
    }

    .bm_panel{
      position:absolute;
      top:110px;
      right:30%;
      z-index: 9;
      width:246px;
      background-color:#fff;
      border-radius: 10px;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      padding: 20px;

      .bmtit{
        text-align: center;
        font-size: 20px;
        color: #00B3A4;

        .bmt2{
          font-size: 10px;
          color: #999999;
          margin: 10px 0;
        }
      }

      .ruleForm{

        .it3{
          .el-icon-s-order{
            position: absolute;
            position: absolute;
            z-index: 1;
            top: 12px;
            left: 10px;
            color: #C0C4CC;
          }

          .el-select{
            width: 100%;

            .el-input__inner{
              padding-left: 30px;
            }

          }
        }

        .it4{
          .el-form-item__content{
            display: flex;
          }
          .el-input{
            width: 50%;
          }

          img{
            width: 103px;
            height: 40px;
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
          }
        }

        .it5{
          margin-bottom: 0;
        }

        .submit_btn{
          width: 100%;
        }

      }

      

    }
  }

  .free_course_box{
    width:1024px;
    margin: 60px auto 0;
   
    .tit{
      background-color:#fff;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      padding:10px 14px;
      border-radius: 5px;
      display:flex;
      align-items:baseline;

      .t1{
        font-size: 20px;
        color: #00B3A4;
      }

      .t2{
        font-size: 16px;
        color: #B3B3B3;
        margin-left:20px;
      }
    }

    .el-carousel{
      margin-top:20px;
    }

    .el-carousel__arrow{
      display: none;
    }

    .el-carousel__button{
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: #CCC;
    }

    .is-active button {
      background-color: #999;
      width: 40px;
      
    }
  }

  .item:nth-child(3n) {
     margin-right: 0;
  }

  .item{
    width:306px;
    height:146px;
    background-color:#fff;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    padding:10px 0;
    border-radius: 5px;
    text-align: left;
    margin-right: 52px;
    display: inline-block;
    margin-bottom: 20px;

    .tit_name{
      display:flex;
      align-items:center;

      .f1{
        width:32%;
        height:35px;
        line-height:35px;
        background-color:#00B3A4;
        color:#fff;
        font-size:16px;
        overflow:hidden;
        padding: 0 6px;
        font-weight: bold;
      }

      .f2{
        width:60%;
        height:35px;
        line-height:35px;
        color:#000;
        font-size:16px;
        overflow:hidden;
        margin-left:6px;
      }

    }

    .tit_info{
      display:flex;
      align-items:center;

      .imgbox{
        width:158px;
        height:106px;
        margin-top: 6px;
        margin-left: 6px;
        cursor: pointer;
        position: relative;

        img{
          width:158px;
          height:106px;
        }

        .playBtn{ 
          position: absolute; 
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          height: 50px; 
          width:50px; 
          -webkit-border-radius: 100%; 
          -moz-border-radius: 100%; 
          -o-border-radius: 100%; 
          border-radius: 100%; 
          margin: auto; 
          background-color: rgba(115, 133, 159, 0.5);
          border: 2px solid #fff; 

          a { 
            border-color: transparent transparent transparent #fff; 
            border-width: 8px 0 8px 12px;  
            width: 0; height: 0; 
            border-style: solid;
            text-indent: -9999px; 
            position: absolute; 
            top: 16px;
            left: 21px; 
          }
        }

      }

      .info{
        font-size:12px;
        color: #808080;
        margin-left:8px;
        width:130px;

        .l{
          display:flex;
          align-items:center;
          margin: 6px 0;

          i{
            color:#00B3A4;
            margin-right:8px;
          }

          span{
            margin-left:8px;
          }
        }
        
      }
    }
  }

  .teacher_box{
    background-color:#EFEEEE;
    margin: 60px auto 0;

    .box{
      width:1024px;
      margin: 0 auto;
      padding: 40px 0;

      .tit{
        font-size: 24px;
        color: #494949;
        text-align: center;
      }

      .content{
        font-size: 14px;
        color: #585959;
        text-align: center;
        line-height: 25px;
        margin-top:20px;
        text-indent: 28px;
      }

      .el-carousel{
        margin-top:20px;
      }

      .tbox{
        width:290px;
        height:364px;
        padding-top: 30px;
        background-color: #fff;
        box-shadow: 1px 1px 0 0 rgba(0,0,0,0.50);
        border-radius: 8px;
        font-size: 14px;
        margin: 0 auto;

        img{
          width:150px;
          height:150px;
          display:block;
          border-radius:75px;
          margin: 0 auto;
        }

        .tname{
          color: #00B3A4;
          text-align:center;
          margin:30px 0;
        }

        .tdesc{
          width:270px;
          height:126px;
          color: #585959;
          line-height: 25px;
          padding: 0 10px;
          overflow:hidden;
        }
      }

      .el-carousel__mask{
        display:none;
      }

      .el-carousel__indicators{
        display:none;
      }
     
    }
  }

  .hot_course_list:nth-child(1){
    margin-top: 60px;
  }

  .hot_course_list{
    width:1024px;
    margin: 0 auto 0;
   
    .tit{
      background-color:#fff;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      padding:10px 14px;
      border-radius: 5px;
      display:flex;
      align-items:baseline;

      .t1{
        font-size: 20px;
        color: #00B3A4;
      }

      .t2{
        font-size: 16px;
        color: #B3B3B3;
        margin-left:20px;
      }
    }

    .el-carousel{
      margin-top:20px;
    }

    .el-carousel__arrow{
      display: none;
    }

    .el-carousel__button{
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: #CCC;
    }

    .is-active button {
      background-color: #999;
      width: 40px;
      
    }
  }

  .banner_box{
    margin: 0px auto 0;

    .box{
      width:1024px;
      margin: 0 auto;
      display:flex;
      justify-content:space-between;
      flex-wrap: wrap;
      padding: 20px 0;

      a{
        font-size: 24px;

        img{
          width:330px;
          height:184px;
          border-radius:10px;
        }
      }
     
    }
  }

  .bottom_banner_box{
    background-color:#EFEEEE;
  }

  .recommend_course_list_box{
    background-color:#EFEEEE;
    padding:0 0 30px;

    .recommend_course_list{
      width:1024px;
      margin: 0 auto;
    
      .tit{
        background-color:#fff;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
        padding:10px 14px;
        border-radius: 5px;
        display:flex;
        align-items:baseline;

        .t1{
          font-size: 20px;
          color: #00B3A4;
        }

        .t2{
          font-size: 16px;
          color: #B3B3B3;
          margin-left:20px;
        }
      }

      .el-carousel{
        margin-top:20px;
      }

      .el-carousel__arrow{
        display: none;
      }

      .el-carousel__button{
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background-color: #CCC;
      }

      .is-active button {
        background-color: #999;
        width: 40px;
        
      }
    }
  }

  .fc{
    position: fixed;
    top:40%;
    right:5%;
    z-index: 99;

    .ma{
      width:50px;
      height:50px;
      background: url(../assets/ma1.png) no-repeat;
      background-size: 100% 100%;
      cursor:pointer;

      .ma_panel{
        width:156px;
        height:142px;
        background: url(../assets/mapanel.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: -48px;
        left: -145px;
        display:none;
      }

      img{
        width:100px;
        position: absolute;
        top: -30px;
        left: -122px;
        display:none;
      }
    }
    .ma:hover{
      background: url(../assets/ma2.png) no-repeat;
      background-size: 100% 100%;

      .ma_panel, img{
        display:block;
      }
    }


    .dh{
      width:50px;
      height:50px;
      background: url(../assets/dh.png) no-repeat;
      background-size: 100% 100%;
      cursor:pointer;
      margin: 10px 0;

      .dh_panel{
        width:268px;
        height:62px;
        background: url(../assets/dhpanel.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 54px;
        left: -256px;
        display:none;
      }

      .dh_num{
        position: absolute;
        top: 75px;
        left: -212px;
        font-size: 16px;
        color: #494949;
        display:none;
      }
    }

    .dh:hover{
      .dh_panel, .dh_num{
        display:block;
      }
    }

    .db{
      width:50px;
      height:50px;
      background: url(../assets/db1.png) no-repeat;
      background-size: 100% 100%;
      cursor:pointer;
    }
    .db:hover{
      background: url(../assets/db2.png) no-repeat;
      background-size: 100% 100%;
    }

    .bm{
      width:50px;
      height:50px;
      margin: 10px 0;
      background: url(../assets/bm1.png) no-repeat;
      background-size: 100% 100%;
      cursor:pointer;
    }
    .bm:hover{
      background: url(../assets/bm2.png) no-repeat;
      background-size: 100% 100%;
    }

    

    

  }

}

</style>
